@if (!isDismissed && hasAnyJobs) {
  <div class="jobs-widget"
    [class.jobs-widget--running]="activeTab === 'running'"
    [class.jobs-widget--completed]="activeTab === 'completed'"
    [class.jobs-widget--scheduled]="activeTab === 'scheduled'"
    [class.sliding-out]="slidingOut"
    (mouseenter)="pauseAutoClose()"
    (mouseleave)="resumeAutoClose()">

    <div class="widget-header">
      <div class="widget-tabs">
        @if (running.length > 0) {
          <button class="widget-tab"
            [class.widget-tab--active]="activeTab === 'running'"
            (click)="selectTab('running')">
            <mat-icon class="tab-icon">sync</mat-icon>
            Running ({{ running.length }})
          </button>
        }
        @if (completed.length > 0) {
          <button class="widget-tab"
            [class.widget-tab--active]="activeTab === 'completed'"
            (click)="selectTab('completed')">
            <mat-icon class="tab-icon">check_circle</mat-icon>
            Done ({{ completed.length }})
          </button>
        }
        @if (scheduled.length > 0) {
          <button class="widget-tab"
            [class.widget-tab--active]="activeTab === 'scheduled'"
            (click)="selectTab('scheduled')">
            <mat-icon class="tab-icon">schedule</mat-icon>
            Scheduled ({{ scheduled.length }})
          </button>
        }
      </div>
      <div class="widget-actions">
        <button class="widget-pin" [class.widget-pin--active]="pinned" (click)="togglePin()"
          [title]="pinned ? 'Unpin' : 'Pin'">
          <mat-icon>push_pin</mat-icon>
        </button>
        <button class="widget-dismiss" (click)="dismiss()">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <div class="widget-body">
      @if (currentJob; as job) {
        <div class="job-card" (click)="$event.stopPropagation()">
          <div class="job-card-top">
            <span class="job-card-title">{{ job.action | formatEnum }}</span>
            <span class="job-card-time">
              @if (activeTab === 'scheduled') {
                {{ formatScheduledTime(job.startDateTime) }}
              } @else {
                {{ timeAgo(job.updatedAt || job.createdAt) }}
              }
            </span>
          </div>
          @if (job.name) {
            <div class="job-card-subtitle">{{ job.name }}</div>
          }
          <div class="job-card-status">
            @if (activeTab === 'running') {
              <mat-progress-bar mode="indeterminate" class="job-progress"></mat-progress-bar>
            }
            @if (activeTab === 'completed') {
              @if (job.status === 'SUCCESS') {
                <div class="status-line success">
                  <mat-icon class="status-icon">check_circle</mat-icon>
                  <span>Completed successfully</span>
                </div>
                <!-- GENERATE_REPORT CTAs -->
                @if (job.action === 'GENERATE_REPORT') {
                  <div class="job-cta-row">
                    <a class="job-cta" (click)="downloadExport.emit(job)">
                      <mat-icon class="cta-icon">download</mat-icon> Download File
                    </a>
                    <a class="job-cta secondary" (click)="viewExports.emit()">
                      <mat-icon class="cta-icon">folder_open</mat-icon> Go to Exports
                    </a>
                  </div>
                }
                <!-- BULK_UPLOAD CTAs -->
                @if (job.action === 'BULK_UPLOAD' || job.action === 'BULK_UPLOAD_TASK') {
                  @if (uploadSummaries[job.id]; as summary) {
                    @if (summary.successfulCount > 0 || summary.duplicateCount > 0 || summary.failedCount > 0) {
                      <div class="upload-summary">
                        @if (summary.successfulCount > 0) {
                          <span class="summary-chip success">{{summary.successfulCount}} imported</span>
                        }
                        @if (summary.duplicateCount > 0) {
                          <span class="summary-chip duplicate">{{summary.duplicateCount}} duplicate</span>
                        }
                        @if (summary.failedCount > 0) {
                          <span class="summary-chip failed">{{summary.failedCount}} failed</span>
                        }
                      </div>
                    }
                  }
                  <div class="job-cta-row">
                    <a class="job-cta" (click)="viewBulkUpload.emit(job)">
                      <mat-icon class="cta-icon">upload_file</mat-icon> View Uploads
                    </a>
                  </div>
                }
              } @else {
                <div class="status-line failure">
                  <mat-icon class="status-icon">error</mat-icon>
                  <span>Failed</span>
                </div>
              }
            }
            @if (activeTab === 'scheduled') {
              <div class="status-line scheduled">
                <mat-icon class="status-icon">schedule</mat-icon>
                <span>Scheduled for later</span>
              </div>
            }
          </div>
        </div>
      } @else {
        <div class="widget-empty">No jobs</div>
      }
    </div>

    @if (activeList.length > 1) {
      <div class="widget-nav">
        <button class="nav-btn" [disabled]="currentIndex === 0" (click)="prev()">
          <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="nav-indicator">{{ currentIndex + 1 }} / {{ activeList.length }}</span>
        <button class="nav-btn" [disabled]="currentIndex === activeList.length - 1" (click)="next()">
          <mat-icon>chevron_right</mat-icon>
        </button>
      </div>
    }
  </div>
}
